"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const component_1 = require("../component");
exports.default = new class DateComponent extends component_1.default {
    defaultOptions = { month: "short", day: "numeric", background: "blueBright", bold: true, padding: 1 };
    get(options) {
        return new Date().toLocaleString("en", options);
    }
    ;
};
